var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"moreBu",on:{"click":function($event){return _vm.gotoLink()}}},[_vm._v("查看更多 "),_c('span',[_vm._v(">>")])])
}
var staticRenderFns = []

export { render, staticRenderFns }